import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    PERMISSION_VACANCIES_READ
  } from '../../constants'
import WithAjax from '../common/helpers/WithAjax'
import {fetchProductionVoiceTestsSuccess} from '../../actions/pages/production-page'
import {checkPermission} from '../common/functions/permissions'
import Table from '../../tables/reactable/DefaultTable'
import StatusBadge from '../common/helpers/StatusBadge'

class VoiceTestsGrid extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.state = {
      itemsPerPage: 10,
      openBtnVisible: checkPermission(PERMISSION_VACANCIES_READ),
      openBtnLabel: 'View',
      search: '',
      filter: {
        Status: ''
      }
    }
    this.columns = [
      'SkillTypeLabel',
      'Description',
      'StartDate',
      'Status',
      'NumberOfCandidates',
      'NumberOfHiredCandidates'
    ]
    this.columnNames = [
      'Speciality',
      'Description',
      'Schedule',
      'Status',
      'Candidates',
      'Confirmed candidates'
    ]
  }

  componentDidMount() {
    if (this.props.voiceTests === null){
      let url = 'productions/' + this.props.productionId + '/voicetests'

      this.props.ajax.get(url, true, (data) => {
        data.forEach((el, index) => {
          data[index].NavigationParam = data[index].Id;
        });

        this.props.fetchProductionVoiceTestsSuccess(data);
      });
    }
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  onFilter(filter){
    this.setState({
      filter: filter
    })
  }

  render() {
    if (this.props.voiceTests === null) {
      return (<div />)
    }

    let items = this.props.voiceTests.map(item => {
      return Object.assign({}, item, {
        Status: (<StatusBadge status={item.Status.toLowerCase()} statusLabel={item.Status} />),
        StartDate: item.StartDate ? (<span startdate={item.StartDate}>{item.Schedule}</span>): (null),
        NumberOfCandidates: item.NumberOfEngagedCandidates + ' of ' + item.NumberOfCandidates
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={this.state.openBtnVisible}
          openBtnLabel={this.state.openBtnLabel}
          openBtnHref="/voicetests/{NavigationParam}/overview"
          searchable={[
            'SkillTypeLabel',
            'Description'
          ]}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={[{
            column: 'Status',
            filters:[
              {
                value: 'draft',
                label: 'Draft'
              },
              {
                value: 'active',
                label: 'Active'
              },
              {
                value: 'booked',
                label: 'Booked'
              },
              {
                value: 'closed',
                label: 'Closed'
              }
            ]
          }]}
          filter={this.state.filter}
          onFilter={this.onFilter}
          sortable={[
            'SkillTypeLabel',
            'Description',
            {
                column: 'Status',
                sortFunction: function(a, b) {
                  return a.props.statusLabel.localeCompare(b.props.statusLabel);
                }
            },
            {
              column: 'StartDate',
              sortFunction: function(a, b) {
                return a.props ? a.props.startdate.localeCompare(b.props.startdate): 0;
              }
            }
          ]}
          defaultSort={{column: 'SkillTypeLabel', direction: 'asc'}}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  voiceTests: state.productionPage.voiceTests
})
const mapDispatchToProps = dispatch => ({
  fetchProductionVoiceTestsSuccess(voiceTests) { dispatch(fetchProductionVoiceTestsSuccess(voiceTests)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(VoiceTestsGrid))
